var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUpTrendIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_963_2363)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.6606 7.62569L8.7533 7.62569L8.75368 4.34646H5.47483L5.47522 5.43953L6.88745 5.43992L3.97528 8.35209L4.74805 9.12486L7.66022 6.21269L7.6606 7.62569Z",
    fill: "#087F46"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8077 2.30686C8.46025 -0.0405996 4.65492 -0.0405996 2.30747 2.30686C-0.0399892 4.65431 -0.0399892 8.45964 2.30747 10.8071C4.65492 13.1546 8.46025 13.1546 10.8077 10.8071C13.1552 8.45964 13.1552 4.65431 10.8077 2.30686ZM10.0351 3.07951C9.11278 2.15722 7.86189 1.63909 6.55759 1.63909C5.25328 1.63909 4.0024 2.15722 3.08012 3.07951C2.15784 4.00179 1.6397 5.25267 1.6397 6.55698C1.6397 7.86128 2.15784 9.11217 3.08012 10.0345C4.0024 10.9567 5.25328 11.4749 6.55759 11.4749C7.86189 11.4749 9.11278 10.9567 10.0351 10.0345C10.9573 9.11217 11.4755 7.86128 11.4755 6.55698C11.4755 5.25267 10.9573 4.00179 10.0351 3.07951Z",
    fill: "#087F46"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_963_2363"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.1143,
    height: 13.1143,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpTrendIcon);
export default __webpack_public_path__ + "static/media/arrow_up_trend_icon.f0dec67b27496979da623c77634a9723.svg";
export { ForwardRef as ReactComponent };